import { render, staticRenderFns } from "./DocumentRegisterModal.vue?vue&type=template&id=5bc69b4f&scoped=true&"
import script from "./DocumentRegisterModal.vue?vue&type=script&lang=js&"
export * from "./DocumentRegisterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc69b4f",
  null
  
)

export default component.exports